import ComparisonPage from './Page';
export default ComparisonPage;
